<template>
  <div class="mt-4 space-y-4">
    <fieldset>
      <legend class="text-sm font-medium text-gray-700 flex items-center">
        {{ legend }}
        <button
          v-if="extraInformation"
          type="button"
          @click="toggleExtraInformation"
          class="ml-2"
          :aria-label="$t('form.show_extra_information_for', { value: legend })"
          :aria-expanded="showExtraInformation ? 'true' : 'false'"
          :aria-controls="`${id}-extra-information`"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </button>
      </legend>
      <div class="mt-1 sm:mt-0 sm:col-span-3">
        <div v-if="showExtraInformation" :id="`${id}-extra-information`">
          <VueMarkdown
            v-if="showExtraInformation"
            class="mt-1 mb-2 text-sm text-gray-700 prose max-w-none"
            :source="extraInformation"
          />
        </div>
      </div>
      <ValidationProvider
        v-slot="{ errors, failed, ariaMsg, ariaInput }"
        :name="label"
      >
        <div
          v-for="option in computedOptions"
          v-bind:key="option"
          class="relative flex items-start"
        >
          <div class="flex items-center h-5">
            <input
              :id="`${id}-${option}`"
              :name="name"
              :value="option"
              :checked="currentValue.includes(option)"
              :disabled="disabled"
              type="checkbox"
              class="focus:ring-blue-500 h-4 w-4 text-indigo-600 border-gray-500 rounded"
              :required="required ? true : false"
              v-bind="ariaInput"
              v-model="currentValue"
              :aria-invalid="failed"
            />
          </div>
          <div class="ml-3 text-sm">
            <label :for="`${id}-${option}`" class="font-medium text-gray-700">{{
              option
            }}</label>
          </div>
        </div>
        <span
          v-bind="ariaMsg"
          aria-live="assertive"
          class="text-sm text-red-700"
        >
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </fieldset>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import VueMarkdown from 'vue-markdown-render';

export default {
  name: 'CheckboxField',
  components: {
    VueMarkdown,
    ValidationProvider,
  },
  props: {
    id: String,
    name: String,
    options: Array,
    value: Array,
    required: Boolean,
    label: String,
    legend: String,
    extraInformation: String,
    disabled: Boolean,
  },
  data() {
    return {
      currentValue: this.value ? this.value : [],
      showExtraInformation: false,
    };
  },
  computed: {
    computedOptions() {
      const value = this.value ? this.value : [];
      return [...new Set([...this.options, ...value])];
    },
  },
  methods: {
    toggleExtraInformation() {
      this.showExtraInformation = !this.showExtraInformation;
    },
  },
};
</script>
